import { ActionTree, ActionContext } from 'vuex'
import { RootState, useStore } from '@/store'
import { state, UserState } from './state'
import { Mutations } from './mutations'
import { UserMutationTypes } from './mutation-types'
import { UserActionTypes } from './action-types'
import { removeRoutes, removeToken, setToken } from '@/utils/cookies'
import { PermissionActionType } from '../permission/action-types'
import router, { resetRouter } from '@/router'
import { RouteRecordRaw } from 'vue-router'
import { PermissionMutationType } from '../permission/mutation-types'

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<UserState, RootState>, 'commit'>

export interface Actions {
  [UserActionTypes.ACTION_LOGIN](
    { commit }: AugmentedActionContext, username: string
  ): void
  [UserActionTypes.ACTION_LOGOUT](
    { commit }: AugmentedActionContext,
  ): void
}

// export const actions: ActionTree<UserState, RootState> & Actions = {
export const actions = {
    // 登录
    [UserActionTypes.ACTION_LOGIN] ( { commit }: AugmentedActionContext, obj ) {
        commit(UserMutationTypes.SET_USERINFO, {...obj.userInfo, timeout_count: obj.timeout_count })
        commit(UserMutationTypes.SET_SHOPRULEDATA, obj.shopRuleData)
        commit(UserMutationTypes.SET_EXPRESSMSG, obj.expressMsg)
        commit(UserMutationTypes.SET_PROMOTIONMSG, obj.promotionMsg)
        commit(UserMutationTypes.SET_STALEDATEMSG, obj.staleDatedMsg)
        commit(UserMutationTypes.SET_OBLIGATIONMSG, obj.obligationMsg)
        commit(UserMutationTypes.SET_RECONCLIATIONMSG, obj.reconciliationMsg)
        commit(UserMutationTypes.SET_CATROLE, obj.catRole)
        commit(UserMutationTypes.SET_STOCKMSG, obj.StockMsg)
        commit(UserMutationTypes.SET_IS_CONTRACTS, obj.is_contracts)
        // localStorage.setItem('userInfo', JSON.stringify(userInfo))
        // localStorage.setItem('shopRuleData', JSON.stringify(shopRuleData))

        // resetRouter()
    },
    // 退出
    [UserActionTypes.ACTION_LOGOUT](
        { commit }: AugmentedActionContext
    ) {
        localStorage.removeItem('userInfo')
        sessionStorage.removeItem('productString')
        sessionStorage.removeItem('isStandardAgree')
        localStorage.removeItem('shopRuleData')
        localStorage.removeItem('expressMsg')
        localStorage.removeItem('promotionMsg')
        localStorage.removeItem('staleDatedMsg')
        localStorage.removeItem('obligationMsg')
        localStorage.removeItem('reconciliationMsg')
        localStorage.removeItem('catRole')
        localStorage.removeItem('StockMsg')
        sessionStorage.removeItem('merchant_qualification_dialog')
        removeRoutes()
        commit(UserMutationTypes.SET_USERINFO, {})
    }
}
